import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Input from '../../../common/Form/Input';
import { addProjectPo, editProjectPo, getProjectPo } from '../../../actions/project';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import FormTable from '../../../common/Form/Table';
import { convertIntoPaisa, convertIntoRupee } from '../../../utils/utils';
import ButtonScogoOrange from '../../../common/Buttons/ButtonScogoOrange';

const formName = 'editPo';
const poArray = 'poArray';

export default function EditProjectPo({ project }) {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const projectPo = useSelector((state) => state.project.projectPo);

    useEffect(() => {
        dispatch(getProjectPo({ projectId: project.id }));
    }, [dispatch, project.id]);

    const methods = useForm({ defaultValues: {}, mode: 'all' });
    const { watch, setValue } = methods;

    useEffect(() => {
        if (projectPo && projectPo.length > 0) {
            setValue(poArray, projectPo.map(({ amount, po_number, po_id }) => {
                return {
                    amount: convertIntoRupee(amount),
                    po_number,
                    po_id
                }
            }));
        } else if (projectPo && projectPo.length === 0) {
            setValue(poArray, [{ id: `${Math.random()}`, isNew: true }])
        }
    }, [projectPo, setValue]);

    const onSave = ({ rowIndex }) => {
        const findData = watch(poArray);
        if (findData && findData[rowIndex]) {
            if (findData[rowIndex].isNew) {
                dispatch(addProjectPo({
                    projectId: project.id,
                    payload: {
                        po_number: findData[rowIndex].po_number,
                        amount: convertIntoPaisa(findData[rowIndex].amount),
                        currency: "INR",
                    },
                    formName: `${formName}_${rowIndex}`
                }));
            } else {
                dispatch(editProjectPo({
                    projectId: project.id,
                    poId: findData[rowIndex].po_number,
                    amount: convertIntoPaisa(findData[rowIndex].amount),
                    formName: `${formName}_${rowIndex}`
                }));
            }
        }
    }

    const schema = {
        table: [
            {
                head: {
                    thClassName: 'w-5/12',
                    headName: 'PO Number',
                    required: true,
                },
                body: {
                    bodyClassName: 'w-5/12 ',
                    render: (_, { rowIndex }) => (
                        <Input
                            name={`${poArray}[${rowIndex}].po_number`}
                            required
                            placeholder={`Po Number`}
                            inputClassName="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-scogoprimary focus:border-transparent"
                            readOnly={!_.isNew}
                        />
                    )
                },
            },
            {
                head: {
                    thClassName: 'w-5/12 pl-4 ',
                    headName: 'PO Amount',
                    required: true,
                },
                body: {
                    bodyClassName: 'w-5/12 ',
                    render: (_, { rowIndex }) => {
                        return (
                            <Input
                                name={`${poArray}[${rowIndex}].amount`}
                                required
                                placeholder={`Po Amount`}
                                inputClassName="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-scogoprimary focus:border-transparent"
                            />
                        );
                    }
                }
            },
            {
                head: {
                    thClassName: 'w-2/12 text-center ',
                    headName: 'Action',
                },
                body: {
                    bodyClassName: 'w-2/12 flex justify-center text-center ',
                    render: (data, { rowIndex, remove }) => {
                        const tableData = watch(poArray);
                        const current = tableData[rowIndex];
                        return <div className='flex items-center gap-3'>
                            <ButtonScogoOrange
                                textOrComponent={data.isNew ? 'Add' : 'Update'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    onSave({ data, rowIndex });
                                }}
                                disabled={(data.isNew && !current)}
                                loading={formButtonLoading[`${formName}_${rowIndex}`]}
                            />
                        </div>

                    }
                },
            },
        ],
    };

    return <Form
        methods={methods}
        onSubmit={() => { }}
        submitButtonText={'Submit'}
        // onCancel={() => dispatch(closeModalAction())}
        // showSubmit
        submitContainerClassName='flex gap-2 justify-end py-4 px-4'
        isLoading={formButtonLoading[formName]}
    >
        <div className='px-4 py-4'>
            <FormTable
                isLoading={false}
                schema={schema}
                name={poArray}
                allowAdd={true}
                addButtonText="Add New Task"
                addButtonClassName="mt-4 mb-2 text-sm font-medium text-scogoprimary hover:text-scogodarker flex items-center gap-2 px-3 py-1.5 border border-scogoprimary rounded-md hover:bg-scogolightblue transition-colors"
                addButtonIcon="add_circle_outline"
                tableClassName="border border-gray-200 rounded-lg overflow-hidden shadow-sm"
                tableHeadClass="bg-gray-100 shadow-sm flex px-2 py-3 text-gray-700 font-medium"
                tableBodyStyle={{ maxHeight: "calc(100vh - 400px)", overflowY: "auto" }}
                rowGenerator={() => ({ id: `${Math.random()}`, isNew: true })}
            />
        </div>
    </Form>
}